import { Component, OnDestroy, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwGridEvent, DwGridEventType, DwQuery, DwQueryFilterGroup, DwQueryHelper } from '@devwareapps/devware-cap';
import { ReportsRepositoryService } from '../../services/reports-repository.service';
import { AcsTrendsConfig, AcsTrendsTab } from '../../models/acs-trends-config.model';
import { FilterConfig } from '../../../shared/models/filter-config.model';
import { AcsTrendsFilterConfig } from '../../models/acs-trends-filter-config';
import { DwChartPreferences, DwChartTypes } from '../../../z-devware/visualizations/models/dw-chart-preferences.model';
import { DwChartDataSelectedEvent } from '../../../z-devware/visualizations/models/dw-chart-data-selected-event.model';
import { DwChartColors } from '../../../z-devware/visualizations/models/dw-chart-colors.model';
import { PilexosUser } from '../../../shared/models/pilexos-user.model';
import { AppMetaData } from '../../../../meta-data/app-meta-data.service';
import { Subscription } from 'rxjs';
import { DwGridColumnPreference } from '@devwareapps/devware-cap';
import { applyReportAccessToFilterConfigs, ReportAccessConfig, ReportAccessPivotDimensionKey } from '../../models/report-access-config.model';
import { ReportAccessService } from '../../services/report-access.service';
import { ChartTileDisplayPreferenceService } from '../../../shared/services/chart-tile-display-preference.service';

@DwComponent({
  key: 'acs-trends-reporting',
  name: 'ACS Trends Reporting',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-acs-trends',
  templateUrl: './acs-trends.component.html',
  styleUrls: ['./acs-trends.component.scss']
})
export class AcsTrendsComponent implements OnInit, OnDestroy {
  pivotDimensions = [
    { key: 'examiner', label: 'Examiner / Check Instructor', field: 'FlightSchoolExaminerIdDisplay' },
    { key: 'checkrideType', label: 'Check Ride Type', field: 'CheckrideTypeIdDisplay' },
    { key: 'attemptClassification', label: 'Attempt Classification', field: 'AttemptClassification' },
    { key: 'testType', label: 'Test Type', field: 'ApplicantAcsWrittenResultTypeIdDisplay' },
    { key: 'flightSchool', label: 'Flight School', field: 'FlightSchoolIdDisplay' },
    { key: 'flightInstructor', label: 'Flight Instructor', field: 'FlightSchoolInstructorIdDisplay' },
    { key: 'acsTest', label: 'ACS Test', field: 'AcsTestIdDisplay' }
  ];
  visiblePivotDimensions: Array<{ key: ReportAccessPivotDimensionKey; label: string; field: string }> = [];

  selectedPivotDimensions: string[] = ['examiner', 'checkrideType'];
  pivotGridConfigKey = 'acs-trends-pivot-grid';
  pivotQuickGridColumnPreferences: DwGridColumnPreference[] = [];
  rankingGridColumnPreferences: DwGridColumnPreference[] = [
    {
      field: 'AcsTestIdDisplay',
      label: 'ACS Test',
      width: 160,
      columnIndex: 0,
    },
    {
      field: 'AreaOfOperationName',
      label: 'Area of Operation',
      width: 220,
      columnIndex: 1,
    },
    {
      field: 'TaskName',
      label: 'Task',
      width: 220,
      columnIndex: 2,
    },
    {
      field: 'AcsCode',
      label: 'ACS Code',
      width: 160,
      columnIndex: 3,
    },
    {
      field: AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName,
      label: 'Times Missed',
      width: 125,
      columnIndex: 4,
    }
  ];
  comparisonGridColumnPreferences: DwGridColumnPreference[] = [
    {
      field: 'AcsTestIdDisplay',
      label: 'ACS Test',
      width: 160,
      columnIndex: 0,
    },
    {
      field: 'AreaOfOperationName',
      label: 'Area of Operation',
      width: 220,
      columnIndex: 1,
    },
    {
      field: 'TaskName',
      label: 'Task',
      width: 220,
      columnIndex: 2,
    },
    {
      field: 'AcsCode',
      label: 'ACS Code',
      width: 200,
      columnIndex: 3,
    },
    {
      field: 'ApplicantAcsWrittenResultTypeIdDisplay',
      label: 'Test Type',
      width: 150,
      columnIndex: 4,
    },
    {
      field: AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName,
      label: 'Times Missed',
      width: 125,
      columnIndex: 5,
    }
  ];

  distributionGridColumnPreferences: DwGridColumnPreference[] = [
    {
      field: 'AreaOfOperationName',
      label: 'Area of Operation',
      width: 250,
      columnIndex: 0,
    },
    {
      field: 'TaskName',
      label: 'Task',
      width: 250,
      columnIndex: 1,
    },
    {
      field: AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName,
      label: 'Times Missed',
      width: 125,
      columnIndex: 2,
    }
  ];

  trendsGridColumnPreferences: DwGridColumnPreference[] = [
    {
      field: 'Period',
      label: 'Period',
      width: 150,
      columnIndex: 0,
    },
    {
      field: AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName,
      label: 'Times Missed',
      width: 125,
      columnIndex: 1,
    }
  ];

  filterConfigs: FilterConfig[] = [];
  currentFilters: DwQueryFilterGroup | null = null;
  securityFilters: DwQueryFilterGroup | null= null;
  pilexosUser: PilexosUser = null as any;
  reportAccessConfig: ReportAccessConfig | null = null;
  
  acsTrendsConfig: AcsTrendsConfig = { tabs: [] };
  currentTab: AcsTrendsTab = null as any;
  currentTabName: string = '';
  
  chartData: any[] = [];
  chartGridData: any[] | null = null;
  pivotGridData: any[] = [];
  chartPreferences: DwChartPreferences | null = null;
  isLoadingChart = false;
  query: DwQuery | null  = null;
  showChartGridFirstByDefault = false;
  readonly chartDataToggleOptions: any = {
    displayStyle: 'blockButtons',
    stateMode: 'twoState',
    trueLabel: 'Charts',
    falseLabel: 'Data'
  };
  
  showGrid = false;
  gridFilters: any = null;
  selectedDataInfo: { event: DwChartDataSelectedEvent<any>; label: string } | null= null;
  private closeGridSubscription: Subscription | null = null;

  constructor(
    private reportsRepository: ReportsRepositoryService,
    private reportAccessService: ReportAccessService,
    private chartTileDisplayPreferenceService: ChartTileDisplayPreferenceService
  ) { }

  ngOnInit(): void {
    this.showChartGridFirstByDefault = this.chartTileDisplayPreferenceService.getReportsShowGridFirst();
    this.subscribeToCloseGrid();
    this.reportAccessService.resolveAccessConfig()
      .subscribe(accessConfig => {
        this.reportAccessConfig = accessConfig;
        this.pilexosUser = accessConfig.pilexosUser;
        this.updateVisiblePivotDimensions();
        this.setupSecurityFilters();
        this.filterConfigs = this.getFilterConfigsForUserRole();
        this.setupTabs();
        this.setActiveTab(this.acsTrendsConfig.tabs[0]?.tabName);
      });
  }

  ngOnDestroy(): void {
    this.closeGridSubscription?.unsubscribe();
  }

  private subscribeToCloseGrid(): void {
    this.closeGridSubscription = this.reportsRepository.getCloseGridObservable()
      .subscribe(() => this.closeDetailGrid());
  }

  /**
   * Sets up the tab configuration for all 5 patterns
   */
  private setupTabs(): void {
    this.acsTrendsConfig = {
      tabs: [
        {
          tabName: 'ranking',
          tabLabel: 'Top Missed Codes',
          iconClass: 'fas fa-chart-bar',
          allowDataDrillDown: true,
          gridConfigKey: 'acs-trends-detail',
          description: 'View the most frequently missed ACS codes ranked by occurrence'
        },
        {
          tabName: 'comparison',
          tabLabel: 'Written vs Exam',
          iconClass: 'fas fa-balance-scale',
          allowDataDrillDown: true,
          gridConfigKey: 'acs-trends-detail',
          description: 'Compare performance between written tests and practical exams'
        },
        {
          tabName: 'distribution',
          tabLabel: 'Area/Task Distribution',
          iconClass: 'fas fa-th',
          allowDataDrillDown: true,
          gridConfigKey: 'acs-trends-detail',
          description: 'View missed codes distributed across Areas of Operation and Tasks'
        },
        {
          tabName: 'trends',
          tabLabel: 'Time Trends',
          iconClass: 'fas fa-chart-line',
          allowDataDrillDown: true,
          gridConfigKey: 'acs-trends-detail',
          description: 'Analyze trends of missed codes over time'
        },
        {
          tabName: 'pivot',
          tabLabel: 'Pivot Grid',
          iconClass: 'fas fa-table',
          allowDataDrillDown: true,
          gridConfigKey: 'acs-trends-detail',
          description: 'Interactive pivot table for custom data exploration'
        }
      ]
    };
  }

  /**
   * Switches to the selected tab and loads its data
   */
  setActiveTab(tabName: string): void {
    this.currentTabName = tabName;
    this.currentTab = this.acsTrendsConfig.tabs.find(t => t.tabName === tabName) as any;
    this.showGrid = false;
    this.selectedDataInfo = null;
    
    this.loadTabData();
  }

  onShowChartGridFirstByDefaultChanged(showGridFirst: boolean): void {
    this.showChartGridFirstByDefault = !!showGridFirst;
    this.chartTileDisplayPreferenceService.setReportsShowGridFirst(this.showChartGridFirstByDefault);
    this.loadTabData();
  }

  /**
   * Handles filter changes from the generic filter component
   */
  onFiltersChanged(filterGroup: DwQueryFilterGroup): void {
    this.currentFilters = this.mergeFilters(filterGroup, this.securityFilters as any);
    this.loadTabData();
  }

  /**
   * Loads data for the current tab based on active filters
   */
  private loadTabData(): void {
    if (!this.currentTab) {
      return;
    }

    this.isLoadingChart = true;
    this.chartData = [];
    this.chartGridData = null;
    this.pivotGridData = [];
    this.query = null;

    switch (this.currentTab.tabName) {
      case 'ranking':
        this.loadRankingData();
        break;
      case 'comparison':
        this.loadComparisonData();
        break;
      case 'distribution':
        this.loadDistributionData();
        break;
      case 'trends':
        this.loadTrendsData();
        break;
      case 'pivot':
        this.loadPivotData();
        break;
    }
  }

  /**
   * Pattern 1: Ranking - Top Missed Codes
   */
  private loadRankingData(): void {
     const attrs = AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes;

    this.chartPreferences = this.applyChartDisplayPreference({
      chartType: DwChartTypes.column,
      categoryField: 'AcsCode',
      gridPreferences: {
        showGrid: true,
        showTotalsRow: true,
        columnPreferences: this.rankingGridColumnPreferences,
      },
      series: [
        {
          chartType: DwChartTypes.column,
          dataField: attrs.MissedCodeCount.fieldName,
          legendDisplay: 'Times Missed',
          backgroundColor: DwChartColors[0]
        }
      ],
      containerTitle: 'Top 20 Missed ACS Codes',
      showContainerTitle: true,
      hideLegend: true
    });

    this.reportsRepository.GetMissedAcsCodesByRanking(this.currentFilters, 20)
      .subscribe(result => {
        this.chartData = result.data;
        this.pivotGridData = this.buildPivotGridData(result.data);
        this.query = result.query;
        this.isLoadingChart = false;
      });
  }

  /**
   * Pattern 2: Comparison - Written vs Exam
   */
  private loadComparisonData(): void {
    this.chartPreferences = this.applyChartDisplayPreference({
      chartType: DwChartTypes.bar,
      categoryField: 'AcsCode',
      gridPreferences: {
        showGrid: true,
        showTotalsRow: true,
        categoryColumnWidth: 200,
        columnPreferences: this.comparisonGridColumnPreferences,
      },
      series: [
        {
          chartType: DwChartTypes.bar,
          dataField: 'WrittenMissedCount',
          legendDisplay: 'Written Test',
          backgroundColor: DwChartColors[2]
        },
        {
          chartType: DwChartTypes.bar,
          dataField: 'ExamMissedCount',
          legendDisplay: 'Practical Exam',
          backgroundColor: DwChartColors[0]
        }
      ],
      containerTitle: 'Written vs Exam Performance - Top 15 Codes',
      showContainerTitle: true,
      hideLegend: false
    });

    this.reportsRepository.GetMissedAcsCodesByWrittenVsExam(this.currentFilters, 15)
      .subscribe(result => {
        this.chartData = result.data;
        this.chartGridData = result.gridData;
        this.query = result.query;
        this.isLoadingChart = false;
      });
  }

  /**
   * Pattern 3: Distribution - Area/Task Heatmap
   */
  private loadDistributionData(): void {
    this.chartPreferences = this.applyChartDisplayPreference({
      chartType: DwChartTypes.bar,
      categoryField: 'AreaOfOperationName',
      gridPreferences: {
        showGrid: true,
        showTotalsRow: true,
        categoryColumnWidth: 250,
        columnPreferences: this.distributionGridColumnPreferences,
      },
      series: [],
      containerTitle: 'Missed Codes by Area of Operation and Task',
      showContainerTitle: true,
      hideLegend: false
    });

    this.reportsRepository.GetMissedAcsCodesByAreaTask(this.currentFilters)
      .subscribe(result => {
        this.chartPreferences = this.applyChartDisplayPreference({
          ...this.chartPreferences!,
          series: this.buildDistributionSeries(result.data)
        });
        this.chartData = this.transformAreaTaskData(result.data);
        this.chartGridData = result.data;
        this.query = result.query;
        this.isLoadingChart = false;
      });
  }

  /**
   * Pattern 4: Time Trends
   */
  private loadTrendsData(): void {
     const attrs = AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes;
    this.chartPreferences = this.applyChartDisplayPreference({
      chartType: DwChartTypes.line,
      categoryField: 'Period',
      gridPreferences: {
        showGrid: true,
        showTotalsRow: true,
        categoryColumnWidth: 150,
        useChartDataForGrid: true,
        columnPreferences: this.trendsGridColumnPreferences,
      },
      series: [
        {
          chartType: DwChartTypes.line,
          dataField: attrs.MissedCodeCount.fieldName,
          legendDisplay: 'Total Missed Codes',
          backgroundColor: DwChartColors[0],
          borderColor: DwChartColors[0]
        }
      ],
      containerTitle: 'Missed ACS Codes Over Time',
      showContainerTitle: true,
      hideLegend: true
    });

    this.reportsRepository.GetMissedAcsCodesByTimePeriod(this.currentFilters)
      .subscribe(result => {
        this.chartData = result.data;
        this.query = result.query;
        this.isLoadingChart = false;
      });
  }

  /**
   * Pattern 5: Pivot Grid
   */
  private loadPivotData(): void {
    // Recreate the quick grid when its dynamic grouping columns change.
    // The CAP quick grid applies column preferences during initialization.
    this.isLoadingChart = true;
    this.chartData = [];
    this.pivotGridData = [];
    this.query = null;

    this.updateVisiblePivotDimensions();
    this.pivotGridConfigKey = this.buildPivotGridConfigKey();
    this.pivotQuickGridColumnPreferences = this.buildPivotQuickGridColumnPreferences();

    this.reportsRepository.GetMissedAcsCodesConfigurableGrid(this.currentFilters, this.selectedPivotDimensions)
      .subscribe(result => {
        this.chartData = result.data;
        this.pivotGridData = this.buildPivotGridData(result.data);
        this.query = result.query;
        this.isLoadingChart = false;
      });
  }

  onPivotDimensionToggled(dimensionKey: string, isChecked: boolean): void {
    if (!this.visiblePivotDimensions.some(dimension => dimension.key === dimensionKey)) {
      return;
    }

    if (isChecked) {
      if (!this.selectedPivotDimensions.includes(dimensionKey)) {
        this.selectedPivotDimensions = [...this.selectedPivotDimensions, dimensionKey];
      }
    } else {
      this.selectedPivotDimensions = this.selectedPivotDimensions.filter(key => key !== dimensionKey);
    }

    if (this.currentTabName === 'pivot') {
      this.loadPivotData();
    }
  }

  /**
   * Handles chart data selection (drill-down)
   */
  onChartDataSelected(event: DwChartDataSelectedEvent<any>): void {
    if (!this.currentTab.allowDataDrillDown) {
      return;
    }

    this.selectedDataInfo = {
      event: event,
      label: `${this.currentTab.tabLabel} - ${event.category || 'Details'}`
    };

    // Build filters for the detail grid based on selected data
    this.gridFilters = this.buildDetailGridFilters(event);

    // Open grid immediately on double-click, or toggle on Ctrl+Click
    if (event?.isDoubleClick) {
      this.showGrid = true;
    } else if (event?.browserEvent?.ctrlKey) {
      this.toggleGrid();
    }
  }

  /**
   * Builds filter criteria for the detail grid based on chart selection
   */
  private buildDetailGridFilters(event: DwChartDataSelectedEvent<any>): any {
    const attrs = AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes;
    const filters: any = this.buildBaseGridFilters();

    if (event.data) {
      // Add specific filters based on the selected data point
      if (event.data.AcsCodeId) {
        filters[attrs.AcsCodeId.fieldNameWithItemPrefix] = event.data.AcsCodeId;
      }
      if (event.data.AcsAreaOfOperationId) {
        filters[attrs.AcsAreaOfOperationId.fieldNameWithItemPrefix] = event.data.AcsAreaOfOperationId;
      }
      if (event.data.AcsAreaOfOperationTaskId) {
        filters[attrs.AcsAreaOfOperationTaskId.fieldNameWithItemPrefix] = event.data.AcsAreaOfOperationTaskId;
      }
      if (event.data.ApplicantAcsWrittenResultTypeId) {
        filters[attrs.ApplicantAcsWrittenResultTypeId.fieldNameWithItemPrefix] = event.data.ApplicantAcsWrittenResultTypeId;
      }
    }

    return filters;
  }

  /**
   * Toggles the detail grid visibility
   */
  toggleGrid(): void {
    this.showGrid = !this.showGrid;
  }

  private closeDetailGrid(): void {
    this.showGrid = false;
    this.gridFilters = null;
    this.selectedDataInfo = null;
  }

  /**
   * Transforms area/task data for stacked bar chart
   */
  private transformAreaTaskData(rawData: any[]): any[] {
    const missedCodeCountField = AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName;

    // Group by Area and pivot by Task
    const areaMap = new Map<string, any>();

    rawData.forEach(item => {
      const area = item.AreaOfOperationName;
      if (!areaMap.has(area)) {
        areaMap.set(area, { AreaOfOperationName: area });
      }
      
      const areaData = areaMap.get(area);
      const taskName = item.TaskName || 'Other';
      areaData[taskName] = (areaData[taskName] || 0) + (item[missedCodeCountField] || 0);
    });

    return Array.from(areaMap.values());
  }

  private buildDistributionSeries(rawData: any[]): any[] {
    const uniqueTasks = Array.from(new Set(rawData.map(item => item.TaskName || 'Other')));

    return uniqueTasks.map((taskName, index) => ({
      chartType: DwChartTypes.bar,
      dataField: taskName,
      legendDisplay: taskName,
      backgroundColor: DwChartColors[index % DwChartColors.length]
    }));
  }

  private buildPivotQuickGridColumnPreferences(): DwGridColumnPreference[] {
    return [
      ...this.visiblePivotDimensions
        .filter(dimension => this.selectedPivotDimensions.includes(dimension.key))
        .map(dimension => ({
          field: dimension.field,
          label: dimension.label,
        })),
      {
        field: AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName,
        label: 'Missed ACS Count',
      }
    ].map((column, index) => ({
      field: column.field,
      label: column.label,
      width: column.field === AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName ? 150 : 220,
      columnIndex: index,
      useFlex: true
    }));
  }

  private buildPivotGridConfigKey(): string {
    const selectedKeys = this.visiblePivotDimensions
      .filter(dimension => this.selectedPivotDimensions.includes(dimension.key))
      .map(dimension => dimension.key);

    return selectedKeys.length > 0
      ? `acs-trends-pivot-grid-${selectedKeys.join('-')}`
      : 'acs-trends-pivot-grid-summary';
  }

  
  onPivotGridEvent(event: DwGridEvent): void {
    if (event.eventType == DwGridEventType.gridRowDoubleClick) {
      const rowData = event.eventData;

      if (!rowData) {
        return;
      }

      if (rowData.__dwIsTotalRow) {
        return;
      }

      this.selectedDataInfo = {
        event: {
          data: rowData,
          browserEvent: event.browserEvent as any,
          category: this.buildPivotSelectionLabel(rowData)
        } as DwChartDataSelectedEvent<any>,
        label: `${this.currentTab.tabLabel} - ${this.buildPivotSelectionLabel(rowData)}`
      };

      this.gridFilters = this.buildPivotDetailGridFilters(rowData);
      this.showGrid = true;
    }
  }

  private applyChartDisplayPreference(chartPreferences: DwChartPreferences): DwChartPreferences {
    const baseShowGridFirst = chartPreferences?.baseShowGridFirst ?? !!chartPreferences?.showGridFirst;

    return {
      ...chartPreferences,
      baseShowGridFirst: baseShowGridFirst,
      showGridFirst: this.showChartGridFirstByDefault || baseShowGridFirst
    };
  }

  private buildPivotGridData(data: any[]): any[] {
    if (!data?.length) {
      return [];
    }

    const totalField = AppMetaData.Queries.ReportingACSMissedCodesAggregate.Attributes.MissedCodeCount.fieldName;
    const labelField = this.visiblePivotDimensions
      .filter(dimension => this.selectedPivotDimensions.includes(dimension.key))
      .map(dimension => dimension.field)
      .find(field => !!field);

    const totalRow: any = {
      __dwIsTotalRow: true,
      [totalField]: data.reduce((sum, row) => {
        const value = Number(row?.[totalField]);
        return sum + (isNaN(value) ? 0 : value);
      }, 0)
    };

    if (labelField) {
      totalRow[labelField] = 'Total';
    }

    for (const columnPreference of this.pivotQuickGridColumnPreferences || []) {
      if (!columnPreference?.field || columnPreference.field === labelField || columnPreference.field === totalField) {
        continue;
      }

      totalRow[columnPreference.field] = '';
    }

    return [...data, totalRow];
  }

  private buildPivotDetailGridFilters(rowData: any): any {
    const attrs = AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes;
    const filters: any = this.buildBaseGridFilters();

    if (this.selectedPivotDimensions.includes('examiner')) {
      this.addPivotDetailFilter(filters, attrs.FlightSchoolExaminerId.fieldNameWithItemPrefix, rowData.FlightSchoolExaminerId);
    }

    if (this.selectedPivotDimensions.includes('checkrideType')) {
      this.addPivotDetailFilter(filters, attrs.CheckrideTypeId.fieldNameWithItemPrefix, rowData.CheckrideTypeId);
    }

    if (this.selectedPivotDimensions.includes('attemptClassification')) {
      this.addPivotDetailFilter(
        filters,
        attrs.CheckRideTestAttemptClassificationId.fieldNameWithItemPrefix,
        rowData.CheckRideTestAttemptClassificationId
      );
    }

    if (this.selectedPivotDimensions.includes('testType')) {
      this.addPivotDetailFilter(filters, attrs.ApplicantAcsWrittenResultTypeId.fieldNameWithItemPrefix, rowData.ApplicantAcsWrittenResultTypeId);
    }

    if (this.selectedPivotDimensions.includes('flightSchool')) {
      this.addPivotDetailFilter(filters, attrs.FlightSchoolId.fieldNameWithItemPrefix, rowData.FlightSchoolId);
    }

    if (this.selectedPivotDimensions.includes('flightInstructor')) {
      this.addPivotDetailFilter(filters, attrs.FlightSchoolInstructorId.fieldNameWithItemPrefix, rowData.FlightSchoolInstructorId);
    }

    if (this.selectedPivotDimensions.includes('acsTest')) {
      this.addPivotDetailFilter(filters, attrs.AcsTestId.fieldNameWithItemPrefix, rowData.AcsTestId);
    }

    return filters;
  }

  private addPivotDetailFilter(filters: any, fieldName: string, value: any): void {
    filters[fieldName] = value === null || value === undefined || value === ''
      ? { IsBlank: true }
      : value;
  }

  private buildBaseGridFilters(): any {
    const filters: any = {};

    if (this.currentFilters?.Filters?.length > 0) {
      filters.groupReportFilters = this.currentFilters;
    }

    return filters;
  }

  private buildPivotSelectionLabel(rowData: any): string {
    const labelParts = this.visiblePivotDimensions
      .filter(dimension => this.selectedPivotDimensions.includes(dimension.key))
      .map(dimension => rowData[dimension.field] || '(Blank)');

    return labelParts.join(' / ') || 'Details';
  }

  private updateVisiblePivotDimensions(): void {
    const hiddenDimensions = this.reportAccessConfig?.hidePivotDimensionKeys || [];
    this.visiblePivotDimensions = this.pivotDimensions
      .filter(dimension => !hiddenDimensions.includes(dimension.key as ReportAccessPivotDimensionKey))
      .map(dimension => ({
        ...dimension,
        label: this.reportAccessConfig?.labelOverrides[dimension.key as ReportAccessPivotDimensionKey] || dimension.label
      })) as Array<{ key: ReportAccessPivotDimensionKey; label: string; field: string }>;

    this.selectedPivotDimensions = this.visiblePivotDimensions
      .filter(dimension => this.selectedPivotDimensions.includes(dimension.key))
      .map(dimension => dimension.key);
  }
  
  /**
   * Sets up security filters based on user role
   */
  private setupSecurityFilters(): void {
    const filterGroup = new DwQueryFilterGroup();
    const qh = new DwQueryHelper();
    const attrs = AppMetaData.RoAssessmentAcsMissedCodeFact.Attributes;

    if (this.reportAccessConfig?.autoFilterValues.checkRideOwnershipTypeId) {
      filterGroup.AddFilterAnd(qh.filters.Equal(
        attrs.CheckRideOwnershipTypeId.fieldNameWithItemPrefix,
        this.reportAccessConfig.autoFilterValues.checkRideOwnershipTypeId
      ));
    }

    if (this.reportAccessConfig?.autoFilterValues.flightSchoolOrganizationId) {
      filterGroup.AddFilterAnd(qh.filters.Equal(
        attrs.FlightSchoolOrganizationId.fieldNameWithItemPrefix,
        this.reportAccessConfig.autoFilterValues.flightSchoolOrganizationId
      ));
    }

    if (this.reportAccessConfig?.autoFilterValues.pilotExaminerId) {
      filterGroup.AddFilterAnd(qh.filters.Equal(
        attrs.PilotExaminerId.fieldNameWithItemPrefix,
        this.reportAccessConfig.autoFilterValues.pilotExaminerId
      ));
    }
  
    this.securityFilters = filterGroup;
    this.currentFilters = this.mergeFilters(null as any, this.securityFilters);
  }

  /**
   * Returns filter configurations appropriate for the current user's role
   */
  private getFilterConfigsForUserRole(): FilterConfig[] {
    const baseConfigs = AcsTrendsFilterConfig.getFilterConfigs();
    return this.reportAccessConfig ? applyReportAccessToFilterConfigs(baseConfigs, this.reportAccessConfig) : baseConfigs;
  }

  /**
   * Merges user-selected filters with automatic security filters
   */
  private mergeFilters(userFilters: DwQueryFilterGroup, securityFilters: DwQueryFilterGroup): DwQueryFilterGroup {
    const merged = new DwQueryFilterGroup();

    // Add security filters first
    if (securityFilters?.Filters?.length > 0) {
      for (const filter of securityFilters.Filters) {
        merged.AddFilterAnd(filter);  
      }
    }

    // Add user filters
    if (userFilters?.Filters?.length > 0) {
      for (const filter of userFilters.Filters) {
        merged.AddFilterAnd(filter);
      }
    }

    return merged;
  }
}
